import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import _ from "lodash"

import { useUser, useLang, useLoading, useMenu } from "../zustand/store.js";

import { TableVirtuoso, Virtuoso } from 'react-virtuoso';
import { toast } from 'react-toastify';

import routes from "../libs/routes";
import images from "../libs/images";
import consts from "../libs/consts";

import { numFormat, errorMessage } from "../utils/utils";
import * as APIS from "../utils/service";

import { LangText } from "../zustand/dict.js";
import { useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import GalleryItem from "../components/GalleryItem.js";
import ArtDetailPopup from "../components/ArtDetailPopup.js";

// import { lang } from '../utils/utils';

export default function ArtGallery() {

    const navigate = useNavigate();
    const [list, setlist] = useState([]);
    const [page, setPage] = useState(1);
    const { setLoading } = useLoading();
    const { getLang } = useLang();
    const { getMenu } = useMenu();
    const { token } = useUser();

    const [detailOpen, setDetailOpen] = useState(false);
    const [photoList, setPhotoList] = useState([]);
    const [photoInfo, setPhotoInfo] = useState(null);

    // const dataFunc = async () => {
    //     console.log('dataFunc!!', page + 1);
    //     let list_dummy = await img_list();

    //     setlist((prev) => [...prev, ...list_dummy]);
    //     setPage((prevPage) => prevPage + 1);
    // }

    const galleryItemClick = (data) => {
        console.log("🚀 ~ galleryItemClick ~ data:", data)
        setPhotoInfo(data);
        setLoading(true)
        setTimeout(() => {
            setLoading(false);
            setDetailOpen(true);
        }, 300)
    }

    const loadPhotoList = () => {
        APIS.post('/user/myArtLike', {}).then(({ data }) => {
            setPhotoList(data)
        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    const likeFunc = (artIdx, like) => {
        if (!token) {
            // setModal({
            //     ...modal,
            //     open: true,
            //     message: getLang({ key: "error_login" })
            // })
            return
        }
        console.log(artIdx, like);
        // return

        APIS.post('/arts/like', {
            type: "image",
            artId: artIdx,
            like: like
        }).then(({ data }) => {
            loadPhotoList()
        }).catch((e) => {
            console.log(e.response.data);
        });
    }


    useEffect(() => {
        console.log("render!!")
        loadPhotoList();
    }, [])

    return (
        <>
            <div className="content">
                <div className="title_box">
                    <p className="title"><LangText id={"text_show_my_work"} /></p>
                    <p className="sub_title"><LangText id={"info_limitday_down"} /></p>
                </div>

                <div className="gallery_box">
                    <div className="art_tab_box">
                        <div className="tab_item" onClick={() => { navigate(routes.myart_history) }}><LangText id={"btn_work_history"} /></div>
                        <div className="tab_item focus" onClick={() => { navigate(routes.myart_gallery) }}><LangText id={"btn_like"} /></div>
                    </div>

                    <InfiniteScroll
                        dataLength={photoList.length}
                        // next={loadPhotoList}
                        hasMore={true}
                    >
                        <ResponsiveMasonry
                            columnsCountBreakPoints={{ 500: 2, 700: 3, 1024: 4 }}
                        >
                            <Masonry
                                gutter="4px"
                            >
                                {photoList.map((x, i) => {
                                    return (
                                        <GalleryItem
                                            key={i}
                                            title={x.user?.name}
                                            item={{
                                                height: x?.height ? x?.height : 1024,
                                                // ratio: x?.height ? `${x?.width}/${x?.height}` : 1,
                                                src: `${consts.imgUrl}${x?.files[0]?.filePath}`
                                            }}
                                            onClick={() => {
                                                galleryItemClick(x);
                                            }}
                                            like={true}
                                            setLike={() => {
                                                likeFunc(x.idx, false)
                                            }}
                                        />
                                    );
                                })}
                            </Masonry>
                        </ResponsiveMasonry>
                    </InfiniteScroll>
                    {photoList.length == 0 && <>
                        <p className="alignc fontb">
                            <LangText id="text_notfound_likeart" />
                        </p>
                    </>}
                </div>

                <ArtDetailPopup
                    open={detailOpen}
                    setOpen={setDetailOpen}
                    data={{
                        menuTitleKey: getMenu({ idx: photoInfo?.menuId })?.title_key,
                        art: {
                            ...photoInfo,
                            myLike: true
                        },
                    }}
                    likeClick={() => {
                        setDetailOpen(false)
                        // likeFunc(photoInfo.art?.idx, !photoInfo.art?.myLike)
                        likeFunc(photoInfo.idx, false)
                    }}
                />
            </div>
        </>
    );
}
